import { VALIDATION } from '../constants/Constants';

export const validateEmail = (email) => {
    if (!email) return 'Email is required';
    if (!VALIDATION.EMAIL_REGEX.test(email)) return 'Invalid email format';
    if (email.length > VALIDATION.MAX_LENGTH.EMAIL) return `Email must be less than ${VALIDATION.MAX_LENGTH.EMAIL} characters`;
    return '';
};

export const validatePhone = (phone) => {
    if (!phone) return 'Phone number is required';
    if (!VALIDATION.PHONE_REGEX.test(phone)) return 'Invalid phone number format';
    if (phone.length > VALIDATION.MAX_LENGTH.PHONE) return `Phone number must be less than ${VALIDATION.MAX_LENGTH.PHONE} characters`;
    return '';
};

export const validateRequired = (value, fieldName, maxLength = null) => {
    if (!value || value.trim() === '') return `${fieldName} is required`;
    if (maxLength && value.length > maxLength) return `${fieldName} must be less than ${maxLength} characters`;
    return '';
};

export const validateForm = (values, schema) => {
    const errors = {};
    
    Object.keys(schema).forEach(field => {
        const value = values[field];
        const validations = schema[field];

        if (validations.required) {
            const error = validateRequired(value, validations.label, validations.maxLength);
            if (error) {
                errors[field] = error;
                return;
            }
        }

        if (validations.type === 'email' && value) {
            const error = validateEmail(value);
            if (error) errors[field] = error;
        }

        if (validations.type === 'phone' && value) {
            const error = validatePhone(value);
            if (error) errors[field] = error;
        }

        if (validations.pattern && value) {
            if (!validations.pattern.test(value)) {
                errors[field] = validations.message || `Invalid ${validations.label.toLowerCase()} format`;
            }
        }

        if (validations.custom) {
            const error = validations.custom(value, values);
            if (error) errors[field] = error;
        }
    });

    return errors;
};

// Example validation schema
export const businessValidationSchema = {
    name: {
        required: true,
        label: 'Business Name',
        maxLength: VALIDATION.MAX_LENGTH.NAME
    },
    description: {
        required: true,
        label: 'Description',
        maxLength: VALIDATION.MAX_LENGTH.DESCRIPTION
    },
    address: {
        // Keep optional to avoid blocking submit when user does not have full address yet
        required: false,
        label: 'Address',
        maxLength: VALIDATION.MAX_LENGTH.ADDRESS
    },
    phone: {
        // Optional in add flow; if provided it will still be validated
        required: false,
        type: 'phone',
        label: 'Phone Number'
    },
    email: {
        // Optional in add flow; if provided it will still be validated
        required: false,
        type: 'email',
        label: 'Email'
    },
    category: {
        required: true,
        label: 'Category'
    },
    city: {
        required: true,
        label: 'City'
    }
}; 